<template>
  <div class="visitorInfo">
    <Header></Header>
    <div class="info" :style="{ minHeight: height + 'px' }" v-if="visible">
      <div class="con">
        <div class="title">
          <span class="name">{{ info.visitorName }}</span>
          <p>
            {{ $t('user.review.time') }}:
            <span>{{ info | allTime }}</span>
          </p>
          <p>
            {{ $t('user.review.reason') }}:
            <span>{{ info.reason }}</span>
          </p>
        </div>

        <div class="qrcode">
          <img :src="newVrcodeUrl" alt />
          <p @click="refresh">
            <Icon name="replay" />
            {{ $t('qrcode.refresh.tips') }}
            <span>{{ $t('qrcode.refresh') }}</span>
          </p>
        </div>
      </div>
    </div>
    <div v-else class="capture">
      <div class="title">{{ $t('visitor.info.title') }}</div>
      <PasswordInput :value="value" :mask="false" :gutter="15" :focused="showKeyboard" @focus="showKeyboard = true" />
      <!-- 数字键盘 -->
      <NumberKeyboard :show="showKeyboard" @input="onInput" @delete="onDelete" @blur="showKeyboard = false" />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { Toast, Icon, PasswordInput, NumberKeyboard } from 'vant';
import api from '@/services/api';
import Header from '@/components/header.vue';
import { replaceUrl } from '@/utils/url-ip-replace';
export default {
  components: { Icon, Header, PasswordInput, NumberKeyboard },
  data() {
    return {
      info: {
        vrcodeUrl: '',
        startTime: null,
        endTime: null,
        visitorName: '',
        reason: '',
      },
      value: '',
      showKeyboard: true,
      visible: false,
      timer: null,
    };
  },
  computed: {
    height() {
      return window.innerHeight - parseInt(document.body.style.fontSize) * 1.17333;
    },
    url() {
      return this.$route.path;
    },
    historyInfo() {
      return window.history.state && window.history.state.info;
    },
    newVrcodeUrl() {
      return replaceUrl(this.info.vrcodeUrl);
    },
  },
  filters: {
    allTime(item) {
      if (item && item.startTime && item.endTime) {
        return moment(item.startTime).format('YYYY-MM-DD HH:mm~') + moment(item.endTime).format('HH:mm');
      }
    },
  },
  methods: {
    initData(value = this.historyInfo) {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$t('empty.loading') + '...',
      });
      api
        .codeInfo({
          captcha: value,
        })
        .then(response => {
          const [success, res] = response;
          Toast.clear();
          if (success) {
            this.initState(value);
            this.visible = true;
            this.info = res.data;
            this.value = value;
          }
        });
    },
    initState(info) {
      window.history.pushState(
        {
          info,
        },
        this.url
      );
    },
    refresh() {
      this.initData(this.value);
    },
    onInput(key) {
      this.value = (this.value + key).slice(0, 6);
      if (this.value.length === 6) {
        this.initData(this.value);
      }
    },
    onDelete() {
      this.value = this.value.slice(0, this.value.length - 1);
    },
  },
  mounted() {
    this.historyInfo && this.initData(this.historyInfo);
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.refresh();
      }, 1000 * 3600 * 10);
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>

<style lang="less" scoped>
.info {
  display: flex;
  justify-content: center;
  align-items: flex-start;

  .con {
    background-color: #ffffff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    width: 600px;
    height: 814px;
    margin-top: 130px;

    .title {
      font-size: 30px;
      color: #3d424d;
      letter-spacing: 0;
      line-height: 45px;
      text-align: left;
      height: 228px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 40px 53px;
      box-sizing: border-box;

      .name {
        font-size: 38px;
        text-align: center;
        line-height: 38px;
        margin-bottom: 20px;
        font-weight: bold;
      }

      p {
        width: 100%;
      }
    }

    .qrcode {
      padding: 50px;

      img {
        width: 405px;
        height: 405px;
      }

      p {
        font-size: 26px;
        color: #7e838c;
        letter-spacing: 0;
        text-align: center;
        line-height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        user-select: none;

        span {
          color: #00ccbf;
          margin-left: 6px;
        }
      }
    }
  }
}
.capture {
  padding: 40px;
  .title {
    margin-top: 100px;
    margin-bottom: 30px;
    font-size: 34px;
    color: #3d424d;
    letter-spacing: 0;
    text-align: left;
    line-height: 50px;
    font-weight: bold;
  }

  .van-password-input {
    margin: 0;
  }
}
</style>
